import React, { useState, useEffect } from 'react';
// import { Modal, Button, Tab, Tabs } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import './pricingComponent.css';
import Swal from 'sweetalert2';


const AddTravellerBtn = React.memo(({ label, onClick }) => (
    <div className="d-flex align-items-center gap-2 mb-3 ps-3">
        <img
            src="\assets\images\Add_Pax.png"
            alt="Add"
            style={{ width: 18, height: 18 }}
        />

        <button
            type="button"
            onClick={onClick}
            style={{
                background: "none",
                border: "none",
                padding: 0,
                color: "#121212CC",
                fontSize: 16,
                cursor: "pointer"
            }}
        >
            {label}
        </button>
    </div>
));

const TravellerBlock = React.memo(
    ({
        label,
        traveller,
        travellerId,
        isInfant = false,
        countryCode = [],
        editable = true,
        handleTravellerChange
    }) => {
        const travellerAge = traveller.dob
            ? Math.floor(
                (new Date() - new Date(traveller.dob)) / (1000 * 60 * 60 * 24 * 365)
            )
            : 0;
        const getDOBRange = (type) => {
            const today = new Date();
            let minDate = "";
            let maxDate = "";

            if (type === "Adult") {
                minDate = new Date(today.getFullYear() - 99, today.getMonth(), today.getDate());
                maxDate = new Date(today.getFullYear() - 12, today.getMonth(), today.getDate());
            } else if (type === "Child") {
                minDate = new Date(today.getFullYear() - 12, today.getMonth(), today.getDate());
                maxDate = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());
            } else if (type === "Infant") {
                minDate = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());
                maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 15);
            }

            return {
                minDate: minDate.toISOString().split("T")[0],
                maxDate: maxDate.toISOString().split("T")[0]
            };
        };

        const { minDate, maxDate } = getDOBRange(traveller.type);

        return (
            <div
                className="travellerFormPricing p-3"
                style={{
                    // background: "#f7fafd",
                    // border: "1px solid #e3ebf5",
                    // borderRadius: 8,
                    // padding: 15
                }}
            >
                {/* ================= HEADER ================= */}
                <div className="d-flex align-items-center gap-2 mb-3">
                    <input
                        type="checkbox"
                        checked={traveller.isOpen}
                        onChange={(e) =>
                            handleTravellerChange(travellerId, "isOpen", e.target.checked)
                        }
                    />
                    <h6 className="mb-0">{label}</h6>
                </div>

                {traveller.isOpen && (
                    <>
                        <div className="row g-3 mb-3">
                            <div className="col-md-4 select-arrow">
                                <label className="form-label label-font-pricing">
                                    Title<span style={{ color: 'red' }}> *</span>
                                </label>
                                <select
                                    className="form-control "
                                    value={traveller.title || "F"}
                                    onChange={(e) => handleTravellerChange(travellerId, 'title', e.target.value)}
                                >
                                    <option value="F">Ms.</option>
                                    <option value="M">Mr.</option>
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label className="form-label label-font-pricing">
                                    First Name<span style={{ color: 'red' }}> *</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter First Name"
                                    value={traveller.firstName || ""}
                                    // disabled={!editable}
                                    onChange={(e) => handleTravellerChange(travellerId, 'firstName', e.target.value)}
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label label-font-pricing">
                                    Last Name<span style={{ color: 'red' }}> *</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Last Name"
                                    value={traveller.lastName || ""}
                                    // disabled={!editable}
                                    onChange={(e) => handleTravellerChange(travellerId, 'lastName', e.target.value)}
                                />
                            </div>
                            <div className="col-md-4 mt-3">
                                <label className='label-font-pricing'>Date of Birth <span style={{ color: 'red' }}> *</span></label>
                                <input
                                    type="date"
                                    className="form-control"
                                    min={minDate}
                                    max={maxDate}
                                    value={traveller.dob || ""}
                                    // disabled={!editable}
                                    onChange={(e) => handleTravellerChange(travellerId, 'dob', e.target.value)}
                                />
                            </div>

                            <div className="col-md-4 mt-3 select-arrow">
                                <label className='label-font-pricing'>Select Nationality</label>
                                <span style={{ color: "red" }}> *</span>
                                <select className="form-control" onChange={(e) => handleTravellerChange(travellerId, 'nationality', e.target.value)} value={traveller.nationality || ""}>
                                    <option value="">Select Nationality</option>
                                    {countryCode.map((country) => (
                                        <option key={country.id} value={country.countryCode}>
                                            {country.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-4 mt-3">
                                <label className='label-font-pricing'>Passport Number</label>
                                <span style={{ color: "red" }}> *</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Passport Number"
                                    value={traveller.passportNumber || ""}
                                    onChange={(e) => handleTravellerChange(travellerId, 'passportNumber', e.target.value)}
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label label-font-pricing">
                                    Passport Issue City <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Issue City"
                                    value={traveller.issueCity || ""}
                                    onChange={(e) =>
                                        handleTravellerChange(travellerId, "issueCity", e.target.value)
                                    }
                                />
                            </div>

                            {/* Passport Issue Date */}
                            <div className="col-md-4">
                                <label className="form-label label-font-pricing">
                                    Passport Issue Date <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    max={new Date().toISOString().split("T")[0]}
                                    value={traveller.issueDate || ""}
                                    onChange={(e) =>
                                        handleTravellerChange(travellerId, "issueDate", e.target.value)
                                    }
                                />
                            </div>
                            <div className="col-md-4 mt-3">
                                <label className='label-font-pricing'>Expiry</label>
                                <span style={{ color: "red" }}> *</span>
                                <input
                                    type="date"
                                    className="form-control"
                                    min={new Date().toISOString()?.split('T')[0]}
                                    value={traveller.expiry || ""}
                                    onChange={(e) => handleTravellerChange(travellerId, 'expiry', e.target.value)}
                                />
                            </div>

                            {traveller.type === "Infant" && (
                                <div className="col-md-4 wheelChairDiv">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={traveller.babyCoat || false}
                                            onChange={(e) => handleTravellerChange(travellerId, 'babyCoat', e.target.checked)}
                                        />
                                        <b className='p-2'>I require Baby Coat</b> (Optional)
                                    </label>
                                </div>
                            )}

                            {traveller.type === 'Adult' && (
                                <div className="col-md-4 wheelChairDiv">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={traveller.wheelChair || false}
                                            onChange={(e) => handleTravellerChange(travellerId, 'wheelChair', e.target.checked)}
                                        />
                                        <b className='p-2'>I require wheelchair</b> (Optional)
                                    </label>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        );
    }
);




const PricingComponent = () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('bearerToken');
    if (bearerToken === '' || bearerToken === undefined || bearerToken === null)
        window.location.href = '/login';
    const navigate = useNavigate();
    const policy = JSON.parse(sessionStorage.getItem('policies'));
    // if (policy === '' || policy === undefined || policy === null) {

    //     window.location.href = '/home';
    // }
    //const mainPolicy = policy[0].policy;
    const user = policy === null ? null : policy[0].user;
    console.log(user);
    const [authorizedBooking, setAuthorizedBooking] = useState(user === null ? false : user.isAdmin ? true : user.authorizedBooking);
    // const [editable, setEditable] = useState(user === null ? true : user.isAdmin ? true : user.authorizedBooking);
    useEffect(() => {
        const handlePopState = (event) => {
            navigate(1);
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);
    const [travellerData, setTravellerData] = useState([]);
    const [show, setShow] = useState(false);
    const [key, setKey] = useState('cancellation');
    const [cartData, setCartData] = useState([]);
    const [airData, setAirData] = useState([]);
    const [baggageModal, setBaggageModal] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handlebaggageModal = () => setBaggageModal(true);
    const handleBaggageClose = () => setBaggageModal(false);
    const [currency, setCurrency] = useState('INR');
    const [cartIds, setCartIds] = useState('');
    const [depAirLine, setDepAirLine] = useState('');
    const [isSecure, setIsSecure] = useState(false);
    const [sessionId, setSessionId] = useState('');
    const [upsellloading, setupsellloading] = useState(false);
    const currencySymbols = {
        INR: '₹',
        EUR: '€',
        USD: '$',
        AED: 'د.إ',
    };
    const getCurrencySymbol = (currencyCode) => {
        return currencySymbols[currencyCode] || currencyCode;
    };

    // INSERT_YOUR_CODE

    // To receive query parameters from URL


    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    // Example: getting 'sc' and 'id' from the query parameters
    const payload = {
        sc: searchParams.get('sc'),
        id: searchParams.get('id')
    };


    const getCartData = async () => {
        setupsellloading(true)
        try {
            const response = await fetch(`${baseUrl}api/Flight/FlightDetail`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // 'Authorization': 'Bearer ' + bearerToken,
                },
                body: JSON.stringify(payload)
            });
            setupsellloading(false);
            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('bearerToken');
                    localStorage.removeItem('policies');
                    sessionStorage.removeItem('policies');
                    localStorage.removeItem('user');
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const result = await response.json();
            console.log("cart result", result)
            // setCartData(result.data.cbtCarts);

            setAirData(result.Data.data);
            const type = result.Data.data
            console.log("final", result.Data.data)
            console.log("final type", typeof type)
            if (airData.length > 0) {
                // setCurrency(airData[0].currency);
                setAdults(airData?.RequestPax?.[0]?.quantity);
                setChildren(airData?.RequestPax?.[1]?.quantity);
                setInfants(airData?.RequestPax?.[2]?.quantity);
            }

            // console.log(result.data.cbtCarts);
            // console.log(result.data.airCartDetails);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const SavePassenger = async () => {
        if (!mobileNumber || !selectedCode) { alert("Enter the Required Field"); return; }
        if (!email) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Field',
                text: 'Enter the Required Field'
            });
            if (!email.includes('@') || !email.includes('.'))
                Swal.fire({
                    icon: 'warning',
                    title: 'Invalid Email',
                    text: 'Enter a valid email address.'
                });
            return;
        }
        if (travellerData.length > 0) {
            for (let traveller of travellerData) {
                if (!traveller.firstName || !traveller.lastName || !traveller.dob) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Missing Field',
                        text: 'Enter the Required Field'
                    });
                    return;
                }
                if (isSecure) {
                    if (!traveller.passportNumber || !traveller.expiry || !traveller.issuingCountry || !traveller.nationality) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Missing Field',
                            text: 'Enter the Required Field'
                        });
                        return;
                    }
                }
            }

            try {
                const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/SavePassenger`, {
                    // const response = await fetch(`${baseUrl}api/Flight/Book`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + bearerToken,
                    },
                    body: JSON.stringify(payload)
                });
                if (!response.ok) {
                    if (response.status === 401) {
                        localStorage.removeItem('bearerToken');
                        localStorage.removeItem('policies');
                        sessionStorage.removeItem('policies');
                        localStorage.removeItem('user');
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                    throw new Error(`Error ${response.status}: ${response.statusText}`);
                }

                const result = await response.text();
                setSessionId(result);
                localStorage.setItem('sessionId', result);
                return result;
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };
    const Book_Issue = async () => {
        try {
            var passenger = await SavePassenger();
            if (passenger !== "" && passenger !== null && passenger !== undefined) {
                const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/OfflinePayment?sessionId=` + passenger, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + bearerToken,
                    },
                });
                if (!response.ok) {
                    if (response.status === 401) {
                        localStorage.removeItem('bearerToken');
                        localStorage.removeItem('policies');
                        sessionStorage.removeItem('policies');
                        localStorage.removeItem('user');
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                    throw new Error(`Error ${response.status}: ${response.statusText}`);
                }

                const result = await response.json();
                console.log(result);
                Swal.fire({
                    title: 'Info',
                    text: result.message,
                    icon: 'info',
                    confirmButtonText: 'OK'
                });
                if (result.message.includes(" Creation Successful")) {
                    var pnr = result.message?.split(':')[1].replace(" Creation Successful", "");
                    pnr = pnr?.split('#')[1];
                    if (pnr) {
                        const responseIssue = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/issue?PNR=` + pnr, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + bearerToken,
                            },
                        });
                        if (!responseIssue.ok) {
                            throw new Error(`Error ${responseIssue.status}: ${responseIssue.statusText}`);
                        }

                        const resultIssue = await responseIssue.text();
                        Swal.fire({
                            title: 'Info',
                            text: resultIssue,
                            icon: 'info',
                            confirmButtonText: 'OK'
                        });
                        window.location.href = "/home";
                    }
                    else {
                        Swal.fire({
                            title: 'Error',
                            text: 'No PNR received.',
                            icon: 'error',
                            confirmButtonText: 'OK'
                        });
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const getPaxLabel = (type, counters) => {
        const normalizedType = String(type).trim().toUpperCase();
      
        counters[normalizedType] = (counters[normalizedType] || 0) + 1;
      
        if (normalizedType === "ADULT") return `Adult ${counters[normalizedType]}`;
        if (normalizedType === "CHILD") return `Child ${counters[normalizedType]}`;
        if (normalizedType === "INFANT") return `Infant ${counters[normalizedType]}`;
      
        return "Traveller";
      };
    const validateBookingData = () => {

        if (!travellerData || travellerData.length === 0) {
            showError("Please add traveller details.");
            return false;
        }

        const expectedPaxCount =
            Number(adults || 0) +
            Number(children || 0) +
            Number(infants || 0);
            const paxCounters = { ADULT: 0, CHILD: 0, INFANT: 0 };

        for (let i = 0; i < travellerData.length; i++)  {
            const t = travellerData[i];
            const label = getPaxLabel(t.type, paxCounters)

            if (!t.firstName?.trim()) {
                showError(`Please enter First Name for ${label}.`);
                return false;
            }

            if (!t.lastName?.trim()) {
                showError(`Please enter Last Name for ${label}.`);
                return false;
            }

            if (!t.dob) {
                showError(`Please select Date of Birth for ${label}.`);
                return false;
            }

            if (!t.nationality) {
                showError(`Please select Nationality for ${label}.`);
                return false;
            }

            if (!t.passportNumber?.trim()) {
                showError(`Please enter Passport Number for ${label}.`);
                return false;
            }

            if (!t.issueCity) {
                showError(`Please select Passport Issuing City for ${label}.`);
                return false;
            }

            if (!t.issueDate) {
                showError(`Please select Passport Issue Date for ${label}.`);
                return false;
            }

            if (!t.expiry) {
                showError(`Please select Passport Expiry Date for ${label}.`);
                return false;
            }
        }
        if (travellerData.length !== expectedPaxCount) {
            showError(`Please add details for all ${expectedPaxCount} travellers.`);
            return false;
        }
        // 📞 Contact validation
        if (!selectedCode || !mobileNumber) {
            showError("Please enter mobile number with country code.");
            return false;
        }

        if (!email) {
            showError("Please enter email address.");
            return false;
        }

        if (!email.includes("@") || !email.includes(".")) {
            showError("Please enter a valid email address.");
            return false;
        }

        // ✅ NOW API CAN BE CALLED
        return true;
    };

    const showError = (message) => {
        Swal.fire({
            icon: "error",
            title: "Validation Error",
            text: message,
            confirmButtonText: "OK",
        });
    };
    const ProcessBooking = async () => {
        if (!validateBookingData()) return;
        try {
            // Construct the payload as in file_context_0
            const payload = {
                sc: searchParams.get("sc"),
                id: searchParams.get("id"),
                paxdata: travellerData.map((traveller, index) => ({
                    paxtype: getPaxType(traveller.type),
                    IsLeadPax: index === 0,
                    paxindex: String(index + 1),
                    title: normalizeTitle(traveller.title),
                    firstname: traveller.firstName,
                    middlename: "",
                    lastname: traveller.lastName,
                    dob: traveller.dob,
                    gender: getGender(traveller.title),
                    nationality: traveller.nationality,
                    passport_details: {
                        number: traveller.passportNumber,
                        country: traveller.nationality,
                        expiry_date: traveller.expiry,
                        issue_date: traveller.issueDate || "2025-01-01",
                        issue_city: traveller.issueCity || "jaipur"
                    },

                    contact_details: index === 0
                        ? {
                            phone_code: selectedCode,
                            phone_number: mobileNumber,
                            email: email
                        }
                        : null,

                    service: null
                }))
            };
            console.log("payload", payload)
            // Send it as the body to the API
            // const response = await fetch("https://cbtapi.blueberry-travel.com/api/FlightBooking/OfflinePayment", {
            const response = await fetch(`${baseUrl}api/Flight/Book`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // 'Authorization': 'Bearer ' + bearerToken,
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('bearerToken');
                    localStorage.removeItem('policies');
                    sessionStorage.removeItem('policies');
                    localStorage.removeItem('user');
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const result = await response.json();
            console.log("FINAL PAYLOAD", payload);
            console.log(result);
            if (result.Status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Booking Confirmed',
                    text: 'Your booking is confirmed!',
                    confirmButtonText: 'OK'
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Booking Not Confirmed',
                    text: 'Booking not confirmed: ' + (result.Data || 'Unknown error'),
                    confirmButtonText: 'OK'
                });
            }
            const userConfirmed = window.confirm(result.message);
            if (userConfirmed) {
                // navigate("/home");
            }
            if (result.message.includes("error")) {
                localStorage.removeItem('bearerToken');
                localStorage.removeItem('policies');
                sessionStorage.removeItem('policies');
                localStorage.removeItem('user');
                sessionStorage.clear();
                window.location.href = '/login';
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toISOString().split("T")[0];
    };
    const adultList = travellerData.filter(t => t.type === "Adult");
    const childList = travellerData.filter(t => t.type === "Child");
    const infantList = travellerData.filter(t => t.type === "Infant");
    const addTraveller = (type) => {
        const currentCount = travellerData.filter(t => t.type === type).length;

        // Limits
        if (type === "Adult" && currentCount >= adults) return;
        if (type === "Child" && currentCount >= children) return;
        if (type === "Infant" && currentCount >= infants) return;

        setTravellerData(prev => [
            ...prev,
            createTraveller(type)
        ]);
    };

    const validateEmail = (e) => {
        const value = e.target.value;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!emailRegex.test(value)) {
            e.target.setCustomValidity('Please enter a valid email address that contains "@" and a domain like ".com".');
        } else {
            e.target.setCustomValidity('');
        }
    };

    const handleTravellerDataInputChange = (index, field, value) => {

        const updatedTravellerData = [...travellerData];
        updatedTravellerData[index] = {
            ...updatedTravellerData[index],
            [field]: value || "",
        };
        setTravellerData(updatedTravellerData);
        if (field === 'nationality')
            setSelectedNationality(value || "");
        if (field === 'issuingCity')
            setSelectedcountry(value || "");
    };

    // const totalAmountAndTax = airData.reduce((totals, item) => {
    //     totals.amount += Math.round(parseFloat(item.amount || 0));
    //     totals.tax += Math.round(parseFloat(item.taxamount || 0));
    //     return totals;
    // }, { amount: 0, tax: 0 });

    const [countryCode, setCountryCode] = useState([]);
    const [selectedCode, setSelectedCode] = useState(user === null ? '' : user.countryCode);
    const [selectedNationality, setSelectedNationality] = useState('');
    const [selectedcountry, setSelectedcountry] = useState('');
    const [mobileNumber, setMobileNumber] = useState(user === null ? '' : user.mobileNo);
    const [adults, setAdults] = useState(1);
    const [children, setChildren] = useState(0);
    const [infants, setInfants] = useState(0);
    const [travellers, setTravellers] = useState([]);
    const [email, setEmail] = useState(user === null ? '' : user.email);
    const [error, setError] = useState('');
    // const checkIfSecure = (airData) => {
    //     const isSecure = airData.some(item => item.itemNumber === "S");
    //     setIsSecure(isSecure);
    // };
    // useEffect(() => {
    //     checkIfSecure(airData);
    // }, [airData]);
    const getcountryCode = async (query) => {
        try {
            const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/getCountryCodeList`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + bearerToken,
                },
            });
            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('bearerToken');
                    localStorage.removeItem('policies');
                    sessionStorage.removeItem('policies');
                    localStorage.removeItem('user');
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            const result = await response.json();
            console.log("countary code", result)
            setCountryCode(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleSelectChange = (e) => {
        setSelectedCode(e.target.value);
    };
    const handleMobileChange = (e) => {
        const value = e.target.value;
        if (value.length <= 10) {
            setMobileNumber(value);
        }
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        if (!value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            setError('Please enter a valid email address.');
        } else {
            setError('');
        }
    };

    const calculateAge = (dob) => {
        const dobDate = new Date(dob);
        const currentDate = new Date();
        const age = currentDate.getFullYear() - dobDate.getFullYear();
        const monthDiff = currentDate.getMonth() - dobDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < dobDate.getDate())) {
            return age - 1;
        }
        return age;
    };
    useEffect(() => {
        if (cartData.length === 0) {
            getCartData();
        }
    }, [cartData]);

    useEffect(() => {
        if (countryCode.length === 0) {
            getcountryCode();
        }
    }, [countryCode]);

    useEffect(() => {
        if (airData && airData.RequestPax && Array.isArray(airData.RequestPax)) {
            setAdults(airData.RequestPax[0]?.quantity || 0);
            setChildren(airData.RequestPax[1]?.quantity || 0);
            setInfants(airData.RequestPax[2]?.quantity || 0);
        }
    }, [airData]);

    // If you want to see the updated values after setState, watch those with another useEffect:
    useEffect(() => {
        console.log("adult", adults, "child", children, "infnate", infants);
    }, [adults, children, infants]);
    // useEffect(() => {

    // useEffect(() => {
    //     if (adults == null || children == null || infants == null) return;

    //     const list = [];

    //     for (let i = 0; i < adults; i++) list.push(createTraveller("Adult"));
    //     for (let i = 0; i < children; i++) list.push(createTraveller("Child"));
    //     for (let i = 0; i < infants; i++) list.push(createTraveller("Infant"));

    //     // Preserve logged-in user data for first Adult
    //     if (list[0]?.type === "Adult") {
    //         list[0] = {
    //             ...list[0],
    //             firstName: user?.fullName?.split(" ")[0] || "",
    //             lastName: user?.fullName?.split(" ")[1] || "",
    //             dob: formatDate(user?.dob)
    //         };
    //     }

    //     setTravellerData(list);
    // }, [adults, children, infants]);
    //     setTravellerData((prev) => {
    //         const total = adults + children + infants;
    //         const updated = [...prev];

    //         for (let i = prev.length; i < total; i++) {
    //             const type =
    //                 i < adults ? "Adult" :
    //                     i < adults + children ? "Child" : "Infant";

    //             updated.push(createTraveller(type));
    //         }

    //         return updated.slice(0, total);
    //     });
    // }, [adults, children, infants]);



    const createTraveller = (type) => ({
        id: Date.now().toString() + Math.random().toString(36).substring(2),
        type,
        title: "M",
        firstName: "",
        middleName: "",
        lastName: "",
        dob: "",
        nationality: "",
        passportNumber: "",
        issuingCountry: "",
        issueDate: "",
        issueCity: "",
        expiry: "",
        wheelChair: false,
        babyCoat: false,
        isOpen: true   // 👈 IMPORTANT
    });


    const normalizeTitle = (value) => {
        if (value === "M") return "Mr";
        if (value === "F") return "Ms";
        return value;
    };

    const getGender = (value) => {
        if (value === "M" || value === "Mr") return 1;
        if (value === "F" || value === "Ms") return 2;
        return 1;
    };

    const getPaxType = (type) => {
        if (type === "Adult") return 1;
        if (type === "Child") return 2;
        if (type === "Infant") return 3;
        return 1;
    };

    const handleTravellerChange = (id, field, value) => {
        setTravellerData(prev =>
            prev.map(t =>
                t.id === id ? { ...t, [field]: value } : t
            )
        );
    };
    // useEffect(() => {
    //     if (Array.isArray(airData) && airData.length > 0) {
    //         if (airData[0].marketingCompany) {
    //             const airline = airData[0].marketingCompany.includes('|')
    //                 ? airData[0].marketingCompany?.split('|')[0]
    //                 : airData[0].marketingCompany;
    //             setDepAirLine(airline);
    //         } else {
    //             //console.log('marketingCompany is undefined');
    //         }
    //     }
    // }, [airData]);
    // useEffect(() => {
    //     if (airData.length > 0) {
    //         setCartIds(airData.map((data) => String(data?.cartId)).join(','));
    //     } else if (cartData.length > 0 && cartIds === "") {
    //         setCartIds(cartData.map((data) => data?.cartId).join(','));
    //     }
    // }, [airData, cartData]);

    return (
        <>

            <div className="pricingContainer">
                {/* <div className="mainNavbarContainer">
                    <div className="navbarBox">
                        <a href="/home"><img src="./assets/logoBBT.png" alt="" className="logoBBTImg" /></a>
                        <img src="./assets/logoutBtn.png" alt="" className="logoutBtnImg" onClick={handleLogout} />
                    </div>
                </div> */}
                <div className="headertwo">
                    <p className="container text-start px-4 py-3">Complete Your Booking</p>
                </div>

                <div className="container row m-auto text-start mainpricingcontainer" >

                    {airData?.price && (
                        <div className="col-lg-3 p-0">
                            <div className="w-100">
                                <div className="fare-summary-card">
                                    <div className="title">Fare Summary</div>
                                    <hr />
                                    <div className="row" style={{ fontSize: "13px" }}>
                                        <div className="col-8 text-muted">Base Fare</div>
                                        <div className="col-4 text-right text-muted">{getCurrencySymbol(airData?.price?.tarriffinfo?.[0]?.currency)}&nbsp;{new Intl.NumberFormat('en-IN').format(airData?.price?.net_base_price || 0)}</div>
                                    </div>
                                    <div className="row mt-2" style={{ fontSize: "13px" }}>
                                        <div className="col-8 text-muted">Taxes &amp; Surcharge</div>
                                        <div className="col-4 text-right text-muted">{getCurrencySymbol(airData?.price?.tarriffinfo?.[0]?.currency)}&nbsp;
                                            {new Intl.NumberFormat('en-IN').format(
                                                Number.isFinite(airData?.price?.net_tax_price) ? airData?.price?.net_tax_price : 0
                                            )}</div>
                                    </div>
                                    {airData?.price?.discount ? (
                                        <div className="row">
                                            <div className="col-8 text-muted">Discounts</div>
                                            <div className="col-4 text-right text-muted">
                                                -{getCurrencySymbol(airData?.price?.tarriffinfo?.[0]?.currency)}
                                                {new Intl.NumberFormat('en-IN').format(Number(airData?.price?.discount))}
                                            </div>
                                        </div>
                                    ) : null}
                                    <hr />
                                    <div className="row">
                                        <div className="col-8 total-amount" style={{ fontSize: "13px" }}>Total Amount</div>
                                        <div className="col-4 text-right total-amount" style={{ fontSize: "13px" }}>{getCurrencySymbol(airData?.price?.tarriffinfo?.[0]?.currency)}&nbsp;{new Intl.NumberFormat('en-IN').format(airData?.price?.total_price)}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-100 mt-3">
                                {/* <div className="promo-codes-card">
                                    <div className="title">
                                        <img
                                            src="./assets/images/promo.png"
                                            style={{ width: 20, height: 20, marginRight: 10 }}
                                        />
                                        Promo Codes
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control promo-code-input"
                                        placeholder="Enter Promo Code Here"
                                    />
                                    <div className="promocodeOptions">
                                        <div className="promo-code-item">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="promoCode"
                                                    id="promoCode1"
                                                />
                                                <label className="form-check-label" htmlFor="promoCode1" style={{ fontSize: "12px" }}>
                                                    <strong>BLUEBERRYTRAVELSNEW</strong>
                                                    <br />
                                                    Get {getCurrencySymbol(currency)} 540 instant discount on your Citi Cards
                                                    <br />
                                                    <a href="#" className="terms">
                                                        Terms &amp; Conditions
                                                    </a>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="promo-code-item promo-code-item-border">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="promoCode"
                                                    id="promoCode2"
                                                />
                                                <label className="form-check-label" htmlFor="promoCode2" style={{ fontSize: "12px" }}>
                                                    <strong>BLUEBERRYTRAVELSFEST</strong>
                                                    <br />
                                                    Get {getCurrencySymbol(currency)} 540 instant discount on your Citi Cards
                                                    <br />
                                                    <a href="#" className="terms">
                                                        Terms &amp; Conditions
                                                    </a>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="promo-code-item promo-code-item-border">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="promoCode"
                                                    id="promoCode3"
                                                />
                                                <label className="form-check-label" htmlFor="promoCode3" style={{ fontSize: "12px" }}>
                                                    <strong>BLUEBERRYTRAVELS50</strong>
                                                    <br />
                                                    Get {getCurrencySymbol(currency)} 540 instant discount on your Citi Cards
                                                    <br />
                                                    <a href="#" className="terms">
                                                        Terms &amp; Conditions
                                                    </a>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    )}
                    <div className="col-lg-9 pricingFlightdetails">
                        {airData?.Flight_Data?.map((Flight_Data, index) => (
                            <div key={index}>
                                <div>
                                    <div className="flight-info mb-3">
                                        {/* <div className="FDHeader"> */}
                                        <div className="FDHeaderListing">
                                            <div className='ListingDetailsDeparture'>
                                                <h6 className='text-dark metropolis-semibold m-0'>{Flight_Data?.flightlist?.[0]?.Departure?.city}</h6>
                                                <> <img src="./assets/images/planeImage.png" alt="" />
                                                    <h6 className='text-dark metropolis-semibold m-0'>{Flight_Data?.flightlist?.[Flight_Data?.flightlist?.length - 1]?.Arrival?.city}</h6></>




                                            </div>
                                            <div className="flight-details m-0">
                                                <span>{new Date(Flight_Data?.flightlist?.[0]?.Departure?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                                    weekday: 'short',
                                                    day: 'numeric',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })} |   {Flight_Data?.flightlist.length > 0 && (
                                                    Flight_Data?.flightlist.length === 1
                                                        ? "Non-stop"
                                                        : `${Flight_Data?.flightlist.length - 1} Stop${Flight_Data?.flightlist.length - 1 > 1 ? "s" : ""}`
                                                )} | {Math.floor(Flight_Data?.totaltime / 60)}h {Flight_Data?.totaltime % 60}m </span>
                                            </div>
                                        </div>
                                        {/* <div className="fareRules" onClick={handleShow} style={{ cursor: 'pointer' }}>
                                            View Fare Rules
                                        </div> */}
                                        {/* </div> */}
                                        {/* <Modal show={show} onHide={handleClose} size="lg" centered>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Fare Rules</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <img
                                                                src={`https://r-xx.bstatic.com/data/airlines_logo/${Flight_Data?.marketingCompany?.split('|')[0]}.png`}
                                                                alt={Flight_Data?.marketingCompany?.split('|')[1]}
                                                                style={{ width: '40px', marginRight: '10px' }}
                                                            />
                                                            {Flight_Data?.marketingCompany?.split('|')[1]}
                                                        </div>
                                                        <div>{Flight_Data?.depCode?.split(',')[2]} <img src="./assets/images/planeImage.png" alt="" />
                                                            {Flight_Data?.isRound === 1 && Flight_Data?.noOfStops === "0" && (
                                                                Flight_Data?.arrCode?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 1 && Flight_Data?.noOfStops === "1" && (
                                                                Flight_Data?.lOlocationArr?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 1 && Flight_Data?.noOfStops === "2" && (
                                                                Flight_Data?.lOlocationArr1?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 1 && Flight_Data?.noOfStops === "3" && (
                                                                Flight_Data?.lOlocationArr2?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 2 && Flight_Data?.retnoOfStops === "0" && (
                                                                Flight_Data?.retarrCode?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 2 && Flight_Data?.retnoOfStops === "1" && (
                                                                Flight_Data?.retLOlocationArr?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 2 && Flight_Data?.retnoOfStops === "2" && (
                                                                Flight_Data?.retLOlocationArr1?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 2 && Flight_Data?.retnoOfStops === "3" && (
                                                                Flight_Data?.retLOlocationArr2?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 3 && Flight_Data?.noOfStops3 === "0" && (
                                                                Flight_Data?.arrCode3?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 3 && Flight_Data?.noOfStops3 === "1" && (
                                                                Flight_Data?.lOlocationArr3?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 3 && Flight_Data?.noOfStops3 === "2" && (
                                                                Flight_Data?.lOlocationArr31?.split(',')[2]
                                                            )}
                                                            {Flight_Data?.isRound === 3 && Flight_Data?.noOfStops3 === "3" && (
                                                                Flight_Data?.lOlocationArr32?.split(',')[2]
                                                            )}</div>
                                                    </div>

                                                    <Tabs
                                                        id="fare-rules-tabs"
                                                        activeKey={key}
                                                        onSelect={(k) => setKey(k)}
                                                        className="mb-3"
                                                    >
                                                        <Tab eventKey="cancellation" title="Cancellation Charges">
                                                            <div>
                                                                <table className="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Time Frame</th>
                                                                            <th>Airline Fee + CBT Fee</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>0 Hours - 4 Hours</td>
                                                                            <td>Adult: Non Refundable</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>4 Hours - 4 Days</td>
                                                                            <td>Adult: {getCurrencySymbol(currency)}{totalAmountAndTax.amount.toFixed(2)} + {getCurrencySymbol(currency)}649</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>4 Days - 365 Days</td>
                                                                            <td>Adult: {getCurrencySymbol(currency)}{totalAmountAndTax.amount.toFixed(2)} + {getCurrencySymbol(currency)}649</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <div className="text-muted departureDivPricing">
                                                                    <span className='text-danger'>*</span>From the Time of Departure
                                                                </div>
                                                            </div>

                                                        </Tab>

                                                        <Tab eventKey="dateChange" title="Date Change Charges">
                                                            <div>
                                                                <table className="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Time Frame</th>
                                                                            <th>Airline Fee + CBT Fee</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>0 Hours - 4 Hours</td>
                                                                            <td>Adult: Non Refundable</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>4 Hours - 4 Days</td>
                                                                            <td>Adult: {getCurrencySymbol(currency)}{totalAmountAndTax.amount.toFixed(2)} + {getCurrencySymbol(currency)}649 + Fare Difference</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>4 Days - 365 Days</td>
                                                                            <td>Adult: {getCurrencySymbol(currency)}{totalAmountAndTax.amount.toFixed(2)} + {getCurrencySymbol(currency)}649 + Fare Difference</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>

                                                            </div>
                                                            <div className="text-muted">
                                                                *From the Time of Departure
                                                            </div>
                                                        </Tab>
                                                    </Tabs>
                                                </Modal.Body>

                                            </Modal> */}
                                        {Flight_Data?.flightlist?.map((flightlist, index, arr) => {
                                            return <div className='listingdataContainer'>
                                                <div className="main-info">
                                                    <div className='flightdetailLeftContainer'>
                                                        <div className="airline">
                                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flightlist?.OperatingAirline.code}.png`} alt={flightlist?.OperatingAirline.name} className="airlineIconimg" />
                                                            <span className='d-flex text-muted'> <h5 className='text-dark metropolis-semibold'> {flightlist?.OperatingAirline.name} </h5> &nbsp; | &nbsp;  {flightlist?.OperatingAirline?.code} • {flightlist?.OperatingAirline?.number} </span>
                                                        </div>

                                                        <div className="flight px-2 py-3 w-100">
                                                            <div className="departure departure-width">
                                                                <h4 className="time metropolis-bold">{flightlist?.Departure?.time}</h4>
                                                                <span className="date text-dark metropolis-semibold">{new Date(flightlist?.Departure?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                                                    weekday: 'short',
                                                                    day: 'numeric',
                                                                    month: 'short',
                                                                    year: 'numeric'
                                                                })}</span>
                                                                <span className="location">{flightlist?.Departure?.city} - {flightlist?.Departure?.Iata}</span>
                                                                <span className="airport">{flightlist?.Departure?.name}</span>

                                                                {flightlist?.Departure?.Terminal && (
                                                                    <h6 className="terminal text-dark metropolis-semibold">
                                                                        Terminal {flightlist.Departure.Terminal}
                                                                    </h6>
                                                                )}
                                                            </div>
                                                            <div className="duration-container duration-container-width">
                                                                <div className="duration-time my-2">{Math.floor(flightlist?.FlightMinutes / 60)}h&nbsp;
                                                                    {flightlist?.FlightMinutes % 60}m</div>
                                                                <div className="duration-graphic">
                                                                    <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                                                </div>
                                                                <div className="duration-type my-2">
                                                                    {arr.length > 0 && (
                                                                        arr.length === 1
                                                                            ? "Non-stop"
                                                                            : `${arr.length - 1} Stop${arr.length - 1 > 1 ? "s" : ""}`
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="arrival arrival-width">
                                                                <h4 className="time metropolis-bold">{flightlist?.Arrival?.time}</h4>
                                                                <span className="date text-dark metropolis-semibold">{new Date(flightlist?.Arrival?.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', {
                                                                    weekday: 'short',
                                                                    day: 'numeric',
                                                                    month: 'short',
                                                                    year: 'numeric'
                                                                })}</span>
                                                                <span className="location">{flightlist?.Arrival?.city} - {flightlist?.Arrival?.Iata}</span>
                                                                <span className="airport">{flightlist?.Arrival?.name}</span>

                                                                {flightlist?.Arrival?.Terminal && (
                                                                    <h6 className="terminal text-dark metropolis-semibold">
                                                                        Terminal {flightlist.Arrival.Terminal}
                                                                    </h6>
                                                                )}

                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="baggage-info">
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <th>Baggage</th>
                                                                    <th>Check-in</th>
                                                                    <th>Cabin</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>Adult</td>
                                                                    <td>{flightlist?.CheckinBaggage?.[0]?.Value === "0Kg" ? "Not include" : flightlist?.CheckinBaggage?.[0]?.Value}</td>
                                                                    <td>{flightlist?.CheckinBaggage?.[1]?.Value === "0Kg" ? "Not include" : flightlist?.CheckinBaggage?.[1]?.Value}</td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                                {index < arr.length - 1 && (
                                                    <div className="flightLayoverOuter my-2 py-1">
                                                        <div className="flightLayover mmtConnectLayover">
                                                            <div className="makeFlex">
                                                                <b style={{ color: "#1FD78A" }}>Change of planes</b>・
                                                                <b>
                                                                    {(() => {
                                                                        const firstArrival = flightlist?.Arrival?.time;
                                                                        const nextDeparture = arr[index + 1]?.Departure?.time;
                                                                        if (!firstArrival || !nextDeparture) return "";

                                                                        const [arrH, arrM] = firstArrival.split(":").map(Number);
                                                                        const [depH, depM] = nextDeparture.split(":").map(Number);

                                                                        let diff =
                                                                            depH * 60 + depM - (arrH * 60 + arrM);
                                                                        if (diff < 0) diff += 24 * 60; // overnight layover

                                                                        const hours = Math.floor(diff / 60);
                                                                        const minutes = diff % 60;

                                                                        return `${hours}h ${minutes}m`;
                                                                    })()}
                                                                </b>
                                                                &nbsp;Layover in {flightlist?.Arrival?.city}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}


                                            </div>
                                        })}


                                        {/* <div className="extraBaggageDiv">
                                            <img src="./assets/images/baggageIcon.png" alt="" />
                                            <p className="m-0 px-2">
                                                Got excess baggage? Don’t stress,buy extra check-in baggage
                                                allowance for {a?.depCode?.split(',')[0]}-{a?.isRound === 1 && a?.noOfStops === "0" && (
                                                    a?.arrCode?.split(',')[0]
                                                )}
                                                {a?.isRound === 1 && a?.noOfStops === "1" && (
                                                    a?.lOlocationArr?.split(',')[0]
                                                )}
                                                {a?.isRound === 1 && a?.noOfStops === "2" && (
                                                    a?.lOlocationArr1?.split(',')[0]
                                                )}
                                                {a?.isRound === 1 && a?.noOfStops === "3" && (
                                                    a?.lOlocationArr2?.split(',')[0]
                                                )}
                                                {a?.isRound === 2 && a?.retnoOfStops === "0" && (
                                                    a?.retarrCode?.split(',')[0]
                                                )}
                                                {a?.isRound === 2 && a?.retnoOfStops === "1" && (
                                                    a?.retLOlocationArr?.split(',')[0]
                                                )}
                                                {a?.isRound === 2 && a?.retnoOfStops === "2" && (
                                                    a?.retLOlocationArr1?.split(',')[0]
                                                )}
                                                {a?.isRound === 2 && a?.retnoOfStops === "3" && (
                                                    a?.retLOlocationArr2?.split(',')[0]
                                                )}
                                                {a?.isRound === 3 && a?.noOfStops3 === "0" && (
                                                    a?.arrCode3?.split(',')[0]
                                                )}
                                                {a?.isRound === 3 && a?.noOfStops3 === "1" && (
                                                    a?.lOlocationArr3?.split(',')[0]
                                                )}
                                                {a?.isRound === 3 && a?.noOfStops3 === "2" && (
                                                    a?.lOlocationArr31?.split(',')[0]
                                                )}
                                                {a?.isRound === 3 && a?.noOfStops3 === "3" && (
                                                    a?.lOlocationArr32?.split(',')[0])} at fab rates.
                                            </p>
                                            <img
                                                src="./assets/images/addPricing.png"
                                                alt="Add Pricing"
                                                onClick={handlebaggageModal}
                                                style={{ cursor: "pointer" }}
                                            />


                                            <Modal show={baggageModal} onHide={handleBaggageClose} size="lg" centered>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Add Extra Baggage</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                   
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <img
                                                                src={`https://r-xx.bstatic.com/data/airlines_logo/${a?.marketingCompany?.split('|')[0]}.png`}
                                                                alt={a?.marketingCompany?.split('|')[1]}
                                                                style={{ width: '40px', marginRight: '10px' }}
                                                            />
                                                            {a?.marketingCompany?.split('|')[1]}
                                                        </div>
                                                        <div>{a?.depCode?.split(',')[2]} <img src="./assets/images/planeImage.png" alt="" />
                                                            {a?.isRound === 1 && a?.noOfStops === "0" && (
                                                                a?.arrCode?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 1 && a?.noOfStops === "1" && (
                                                                a?.lOlocationArr?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 1 && a?.noOfStops === "2" && (
                                                                a?.lOlocationArr1?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 1 && a?.noOfStops === "3" && (
                                                                a?.lOlocationArr2?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 2 && a?.retnoOfStops === "0" && (
                                                                a?.retarrCode?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 2 && a?.retnoOfStops === "1" && (
                                                                a?.retLOlocationArr?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 2 && a?.retnoOfStops === "2" && (
                                                                a?.retLOlocationArr1?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 2 && a?.retnoOfStops === "3" && (
                                                                a?.retLOlocationArr2?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 3 && a?.noOfStops3 === "0" && (
                                                                a?.arrCode3?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 3 && a?.noOfStops3 === "1" && (
                                                                a?.lOlocationArr3?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 3 && a?.noOfStops3 === "2" && (
                                                                a?.lOlocationArr31?.split(',')[2]
                                                            )}
                                                            {a?.isRound === 3 && a?.noOfStops3 === "3" && (
                                                                a?.lOlocationArr32?.split(',')[2]
                                                            )}</div>
                                                    </div>
                                                    <div>
                                                        <p className='mt-2'>Included check-in baggage per person - <span style={{ color: "#167182" }}>15 KGS </span></p>
                                                        <div className='baggageModalOptions'>
                                                            <div className='baggageModalContent mt-2'> <p className='m-0'><img src="./assets/images/baggageiconIMage.png" alt="" /> Additional 3 KG - {getCurrencySymbol(currency)}1,242</p> <div className='baggageAddBtn'>+ Add</div></div>
                                                            <div className='baggageModalContent mt-2'> <p className='m-0'><img src="./assets/images/baggageiconIMage.png" alt="" /> Additional 3 KG - {getCurrencySymbol(currency)}1,242</p> <div className='baggageAddBtn'>+ Add</div></div>
                                                            <div className='baggageModalContent mt-2'> <p className='m-0'><img src="./assets/images/baggageiconIMage.png" alt="" /> Additional 3 KG - {getCurrencySymbol(currency)}1,242</p> <div className='baggageAddBtn'>+ Add</div></div>
                                                            <div className='baggageModalContent mt-2'> <p className='m-0'><img src="./assets/images/baggageiconIMage.png" alt="" /> Additional 3 KG - {getCurrencySymbol(currency)}1,242</p> <div className='baggageAddBtn'>+ Add</div></div>
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>

                                        </div> */}
                                    </div>
                                </div>
                                {/* <div className="w-100 mt-3">
                                        <div className="refund-policy-card">
                                            <div className="refund-policy-header">
                                                <h5>Cancellation Refund Policy</h5>
                                                <button className="fareRules" onClick={handleShow} style={{ cursor: 'pointer' }}>View Policy</button>
                                            </div>
                                            <div className="detailsDiv">
                                                <p>{a?.depCode?.split(',')[2]} <img src="./assets/images/planeImage.png" alt="" />
                                                    {a?.isRound === 1 && a?.noOfStops === "0" && (
                                                        a?.arrCode?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 1 && a?.noOfStops === "1" && (
                                                        a?.lOlocationArr?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 1 && a?.noOfStops === "2" && (
                                                        a?.lOlocationArr1?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 1 && a?.noOfStops === "3" && (
                                                        a?.lOlocationArr2?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 2 && a?.retnoOfStops === "0" && (
                                                        a?.retarrCode?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 2 && a?.retnoOfStops === "1" && (
                                                        a?.retLOlocationArr?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 2 && a?.retnoOfStops === "2" && (
                                                        a?.retLOlocationArr1?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 2 && a?.retnoOfStops === "3" && (
                                                        a?.retLOlocationArr2?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 3 && a?.noOfStops3 === "0" && (
                                                        a?.arrCode3?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 3 && a?.noOfStops3 === "1" && (
                                                        a?.lOlocationArr3?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 3 && a?.noOfStops3 === "2" && (
                                                        a?.lOlocationArr31?.split(',')[2]
                                                    )}
                                                    {a?.isRound === 3 && a?.noOfStops3 === "3" && (
                                                        a?.lOlocationArr32?.split(',')[2]
                                                    )}</p>
                                            </div>
                                            <div className="refund-policy-cancellation">
                                                <div className="cancellation1 p-0">
                                                    <div>Cancellation Penalty</div>
                                                    <div>Cancellation Between (IST)</div>
                                                </div>
                                                <div className="cancellation2">
                                                    <div className="w-75 m-auto">
                                                        <h6>{getCurrencySymbol(currency)}{totalAmountAndTax.amount.toFixed(2)}</h6>
                                                        <h6>{getCurrencySymbol(currency)}{totalAmountAndTax.amount.toFixed(2)}</h6>
                                                    </div>
                                                    <div>
                                                        <img src="./assets/images/line.png" alt="" className="mx-2" />
                                                    </div>
                                                    <div>
                                                        <h6>Now</h6>
                                                        <h6 className="ml-5">{new Date(a?.depDt).toLocaleDateString('en-US', {
                                                            weekday: 'short',
                                                            day: 'numeric',
                                                            month: 'short'
                                                        })} | {a?.departureTime}</h6>
                                                        <h6>{new Date(a?.depDt).toLocaleDateString('en-US', {
                                                            weekday: 'short',
                                                            day: 'numeric',
                                                            month: 'short'
                                                        })} | {a?.departureTime}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <h6 className="mt-3">Get more benefits upgrading your fare</h6>
                                            <div className="benefitsContainer">
                                                <div className="benefitsDiv">
                                                    <div className="benefitPriceDiv">
                                                        <h4>{getCurrencySymbol(currency)} {totalAmountAndTax.amount.toFixed(2)}</h4>
                                                        <p>Regular</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/included.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/included.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/included.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/not.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                </div>
                                                <div className="benefitsDiv">
                                                    <div className="benefitPriceDiv">
                                                        <h4>{getCurrencySymbol(currency)} {totalAmountAndTax.amount.toFixed(2)}</h4>
                                                        <p>Regular</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/included.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/included.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/included.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/not.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                </div>
                                                <div className="benefitsDiv">
                                                    <div className="benefitPriceDiv">
                                                        <h4>{getCurrencySymbol(currency)} {totalAmountAndTax.amount.toFixed(2)}</h4>
                                                        <p>Regular</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/included.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/included.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/included.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                    <div className="benefitListDiv">
                                                        <img src="./assets/images/not.png" alt="" className="mt-1" />
                                                        <p className="mx-2">Free Cancellation upp to 24 hours before departure</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="pricingTnC mt-1 mx-2">View T&C</p>
                                        </div>
                                    </div> */}
                                {/* <div className="w-100 mt-3">
                                        <div className="important-info-card">
                                            <div className="important-info-header">Important Information</div>
                                            <div className="info-item">
                                                <div className="info-icon">
                                                    <img src="./assets/images/infoIcon.png" alt="" />
                                                </div>
                                                <div className="info-content">
                                                    <h6>Nearby Airport</h6>
                                                    <p>
                                                        Your flight goes to Ras Al Khaimah, near Dubai International.
                                                        Please note, this is not the airport you originally searched
                                                        for. Kindly check all the routes to your desired destination to
                                                        avoid any hassles in your journey.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="info-item">
                                                <div className="info-icon">
                                                    <img src="./assets/images/infoIcon.png" alt="" />
                                                </div>
                                                <div className="info-content">
                                                    <h6>Passengers travelling to UAE, please note</h6>
                                                    <p>
                                                        Passengers travelling on a 'Tourist' or 'Visit' visa must carry
                                                        a latest 6 month bank statement showing sufficient funds to
                                                        cover expenses in the UAE, with a minimum balance or credit
                                                        limit of AED 3000.
                                                    </p>
                                                    <p>Minors (under 18 years):</p>
                                                    <ul className="p-0">
                                                        <li>- Tourist Visa: Must be accompanied by either parent.</li>
                                                        <li>
                                                            - Unaccompanied Minor on Visit Visa: Must have a family visa
                                                            issued by either a parent or a sponsor.
                                                        </li>
                                                        <li>
                                                            - Family-Sponsored Visit Visa: If traveling with a close
                                                            family member or relative, or as an Unaccompanied Minor, one
                                                            parent must be present in the UAE on a residence visa to
                                                            receive the child.
                                                        </li>
                                                        <li>
                                                            - A copy of the parent's residence visa is required for
                                                            Immigration clearance at the UAE airport.
                                                        </li>
                                                        <li>
                                                            - If not a family visit, either parent must accompany the
                                                            child.
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="info-item">
                                                <div className="info-icon">
                                                    <img src="./assets/images/infoIcon.png" alt="" />
                                                </div>
                                                <div className="info-content">
                                                    <h6>Indigo Travellers, please note</h6>
                                                    <p>
                                                        Passengers are allowed to carry only one handbag throughout the
                                                        journey. Do check the IndiGo website for more details.
                                                    </p>
                                                    <p>
                                                        Passengers are required to follow updated check-in baggage
                                                        guidelines as below. Any baggage that exceeds the above
                                                        dimensions will be charged oversized baggage handling fees.
                                                    </p>
                                                    <p>
                                                        Cartons: 51cm x 61cm x 46cm - 158cm (Length + Width + Height)
                                                    </p>
                                                    <p>
                                                        Suitcase: 76cm x 51cm x 31cm - 158cm (Length + Width + Height)
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                            </div>
                        ))}

                        {airData?.Flight_Data?.length > 0 && (
                            <div className="w-100">

                                {/* ================= Traveller Details Card ================= */}
                                <div
                                    className="form-section"
                                    style={{
                                        border: "1px solid #c0d3ef",
                                        borderRadius: 8,
                                        background: "#fff",

                                        margin: "0 auto"
                                    }}
                                >
                                    <div className="form-header">Traveler Details</div>

                                    {/* ================= ADULT SECTION ================= */}
                                    {travellerData
                                        .filter(t => t.type === "Adult")
                                        .map((traveller, i) => (
                                            <TravellerBlock
                                                key={traveller.id}
                                                label={`Adult ${i + 1}`}
                                                traveller={traveller}
                                                travellerId={traveller.id}
                                                countryCode={countryCode}
                                                handleTravellerChange={handleTravellerChange}
                                            />
                                        ))}
                                    {adults > 0 && travellerData.filter(t => t.type === "Adult").length < adults && (
                                        <AddTravellerBtn
                                            label="Add New Adult"
                                            onClick={() => addTraveller("Adult")}
                                        />
                                    )}
                                    {/* ================= CHILD SECTION ================= */}
                                    {travellerData
                                        .filter(t => t.type === "Child")
                                        .map((traveller, i) => (
                                            <TravellerBlock
                                                key={traveller.id}
                                                label={`Child ${i + 1}`}
                                                traveller={traveller}
                                                travellerId={traveller.id}
                                                countryCode={countryCode}
                                                handleTravellerChange={handleTravellerChange}
                                            />
                                        ))}
                                    {children > 0 && travellerData.filter(t => t.type === "Child").length < children && (
                                        <AddTravellerBtn
                                            label="Add New Child"
                                            onClick={() => addTraveller("Child")}
                                        />
                                    )}
                                    {travellerData
                                        .filter(t => t.type === "Infant")
                                        .map((traveller, i) => (
                                            <TravellerBlock
                                                key={traveller.id}
                                                label={`Infant ${i + 1}`}
                                                traveller={traveller}
                                                travellerId={traveller.id}
                                                isInfant
                                                countryCode={countryCode}
                                                handleTravellerChange={handleTravellerChange}
                                            />
                                        ))}
                                    {infants > 0 && travellerData.filter(t => t.type === "Infant").length < infants && (
                                        <AddTravellerBtn
                                            label="Add New Infant"
                                            onClick={() => addTraveller("Infant")}
                                        />
                                    )}
                                    {/* ================= BOOKING DETAILS (LAST ONLY) ================= */}

                                    <div className="pricingBookingDetails">
                                        <div className="row" style={{ fontSize: "14px" }}>
                                            <p>Booking details will be sent to</p>
                                            <div className="col-md-4 select-arrow">
                                                <label className="form-label">
                                                    Country<span style={{ color: 'red' }}> *</span>
                                                </label>
                                                <select className="form-control" onChange={handleSelectChange} value={selectedCode}>
                                                    <option value="">Select Country</option>
                                                    {countryCode.map((country) => (
                                                        <option key={country.id} value={country.mobileCode}>
                                                            {country.name} (+{country.mobileCode})
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">
                                                    Mobile Number<span style={{ color: 'red' }}> *</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Mobile Number"
                                                    value={mobileNumber}
                                                    onChange={handleMobileChange}
                                                    maxLength={10}
                                                    required
                                                    // disabled={!editable}
                                                    onInvalid={(e) => e.preventDefault()}
                                                    style={{ appearance: 'none', MozAppearance: 'textfield' }}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">
                                                    Email<span style={{ color: 'red' }}> *</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Enter Email"
                                                    value={email}
                                                    onChange={handleEmailChange}
                                                    required
                                                    // disabled={!editable}
                                                    onInvalid={(e) => validateEmail(e)}
                                                    onInput={(e) => e.target.setCustomValidity('')}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                {/* ================= CONTINUE BUTTON ================= */}
                                <div className="pricingBtnDiv text-center mt-4">
                                    <button
                                        className="pricingContinueBooking"
                                        onClick={ProcessBooking}
                                        style={{

                                            padding: "12px 0",

                                        }}
                                    >
                                        Continue Booking
                                    </button>
                                </div>

                            </div>
                        )}

                    </div>

                </div>
            </div>
            {upsellloading && (
                <>
                    <div className="loaderbg"></div>

                    <div className="loaderUpselling">
                        <img src="./assets/images/Flight-price-loader.gif" alt="Loading" />
                    </div>
                </>
            )}
        </>
    );
};

export default PricingComponent;